import '../../../App.css';
import { toast } from 'react-toastify';
function showSuccess(message) {
    var x = document.getElementById("snackbar");
    x.innerHTML = message;
    x.className = "show";
    x.style.color = "white";
    x.style.backgroundColor = "Green";
    setTimeout(function () { x.className = x.className.replace("show", ""); }, 5000);
}
function showWarning(message){
    toast.warning(message, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
    });
};

function showInfo(message, position = 'bottom-right', period = 5000){
    toast.info(message, {
        position: position,
        type: toast.TYPE.INFO,
        autoClose: period,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
    });
};

function loadingResponse(message){
    return toast.loading(message, {
        position: "bottom-right",
        autoClose: false,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
    });
};
function successResponse(message, position = 'bottom-right', period = 5000){
    toast.success(message, {
        position: position,
        type: toast.TYPE.SUCCESS,
        autoClose: period,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
    });
};
function showError(message){
    toast.error(message, {
        position: "bottom-right",
        type: toast.TYPE.ERROR,
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
    });
};

/** Displays a toast notification for a promise request.
 * 
 * @param {Promise} promise - The promise to be tracked.
 * @param {string} pendingMsg - Message to display while the promise is pending.
 * @param {string} successMsg - Message to display when the promise is resolved successfully.
 * @param {string} errorMsg - Message to display when the promise is rejected.
 * @param {number} [period=5000] - Duration (in milliseconds) for which the toast notification is displayed. Defaults to 5000
 */
function showRequest(promise, pendingMsg, successMsg, errorMsg, position = 'bottom-right', period = 5000){
    const toastConfig = {
        pending: pendingMsg !== '' ? pendingMsg : 'Request is pending',
        error: errorMsg !== null ? errorMsg : 'Request rejected'
    };
    // Only add success message if provided (not null/undefined/empty)
    if(successMsg !== null && successMsg !== undefined && successMsg !== ''){
        toastConfig.success = successMsg;
    }
    toast.promise(promise, toastConfig, {
        // position: "bottom-right",
        position: position,
        autoClose: period,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        // transition: 
        // theme: "colored",
    });
};


function showLoader(message) {
    var x = document.getElementById("loading");
    var y = document.getElementById("loading-text");
    y.innerHTML = message === '' && 'LOADING...';
    x.className = "show";
}
function hideLoader() {
    var x = document.getElementById("loading");
    var y = document.getElementById("loading-text");
    y.innerHTML = '';
    x.className = x.className.replace("show", "");
}
export { 
    showSuccess, 
    showError, 
    showLoader, 
    hideLoader, 
    loadingResponse, 
    successResponse, 
    showRequest, 
    showWarning, 
    showInfo
};